
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.424 7.293l-2.967-.008c0 .106-.001.233-.003.316.252.006.897.122 1.1.645l-2.843 6.458c-.139-.32-1.46-3.21-1.612-3.583l1.375-2.806c.284-.427.826-.703 1.351-.723l-.001-.293-2.855-.003c-.007.075 0 .231-.01.309.805.021 1.093.199.9.672a63.232 63.232 0 01-1.117 2.308c-.409-.84-.668-1.487-1.113-2.395-.192-.422.232-.585.68-.598v-.295l-3.307-.01c.003.139-.003.216-.003.318.461.007 1.059.055 1.298.45.316.606 1.37 3.012 1.689 3.656-.407.769-1.395 2.587-1.75 3.268-.507-1.108-2.383-5.472-2.913-6.598-.198-.48.565-.757 1.007-.777l.003-.32-3.761-.001c0 .096.004.255.004.326.61-.005 1.502.98 1.756 1.593 1.098 2.508 2.23 5 3.323 7.51 0 .004.341.009.345.001.715-1.44 1.55-2.953 2.304-4.409l1.903 4.411s.315.003.317.001c1.206-2.714 3.014-6.878 3.605-8.193.24-.562.643-.904 1.294-.924l.005-.291-.004-.015z","fill-rule":"evenodd"}})])
          )
        }
      }
    